import React, { FC } from 'react';
import { Box, useTheme } from '@mui/material';
import Header from '../../components/Header';
import { tokens } from '../../theme';
import NewsletterAdsTimelineTable from '../../components/newsletter-ads/NewsletterAdsTimelineTable';

const NewsletterAdsTimeline: FC = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="20px">
      <Header
        title="Newsletter Ads Timeline"
        subtitle="Historical view of all newsletter advertisements with control code tracking"
      />
      <Box
        display="grid"
        gridTemplateColumns="1fr"
        gap="20px"
        sx={{
          backgroundColor: colors.primary[400],
          padding: '20px',
          borderRadius: '8px',
        }}
      >
        <NewsletterAdsTimelineTable />
      </Box>
    </Box>
  );
};

export default NewsletterAdsTimeline;
